import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { CallToAction, Heading } from '@scentregroup/ui'
import { occurrencesType, callToActionType } from '../../types'
import ExternalLink from '../external-link'
import IconRow from '../icon-row'
import Occurrences from '../occurrences'
import InfoAccordion from '../info-accordion'
import PageSharer from '../page-sharer'
import EventNotification from '../event-notification'
import ArticleHeading from './article-heading'
import style from './index.scss'

const Article = props => (
  <article className={classNames(style.Article, props.className)}>
    <div className={style.containFlexChildrenForIE11}>
      {props.superheading && (
        <Heading
          type="extrasmall"
          className={style.superHeading}
          data-test-id={props.headerDataTestId}
        >
          {props.superheading}
        </Heading>
      )}

      {props.superheading && props.superheading.toUpperCase() === 'EVENT' && (
        <EventNotification className={style.warningNotification} />
      )}
      <ArticleHeading
        type={props.headingType}
        link={props.link}
        dataTestId={props.dataTestId}
      >
        {props.heading}
      </ArticleHeading>
      {props.subheading && (
        <Heading
          type="small"
          className={style.subHeading}
          data-test-id={props.dataTestId}
        >
          {props.subheading}
        </Heading>
      )}

      {props.location && props.location.length && (
        <IconRow text={props.location} icon="location-drop-pin" />
      )}
      {props.hoursText && <IconRow text={props.hoursText} icon="hours" />}
      {props.occurrences && (
        <Occurrences
          occurrences={props.occurrences}
          location={props.location}
        />
      )}
      {props.infoAccordion && (
        <InfoAccordion metaRows={props.infoAccordion} purpose="Event details" />
      )}
      {props.pastEventsAccordion && (
        <InfoAccordion
          metaRows={props.pastEventsAccordion}
          purpose="Past events"
        />
      )}
      {props.times && <div className={style.times}>{props.times}</div>}
      {(props.callsToAction || props.shareButtonType) && (
        <div className={style.ctaWrapper}>
          {(props.callsToAction || []).map(cta => (
            <CallToAction
              fullWidth
              element={ExternalLink}
              className={style.cta}
              key={cta.address}
              url={cta.address}
            >
              {cta.category}
            </CallToAction>
          ))}
          {props.shareButtonType && (
            <PageSharer
              fullWidth
              className={style.cta}
              shareButtonType={props.shareButtonType}
            />
          )}
        </div>
      )}
      <div className={style.body}>{props.children}</div>
    </div>
  </article>
)

Article.propTypes = {
  occurrences: occurrencesType,
  superheading: PropTypes.string,
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string,
  times: PropTypes.string,
  location: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  link: PropTypes.string,
  headingType: PropTypes.oneOf(['large', 'medium', 'small']),
  callsToAction: callToActionType,
  hoursText: PropTypes.string,
  infoAccordion: PropTypes.array,
  pastEventsAccordion: PropTypes.array,
  shareButtonType: PropTypes.string,
  headerDataTestId: PropTypes.string,
  dataTestId: PropTypes.string,
}

Article.defaultProps = {
  headingType: 'large',
}

export default Article
